module.exports = __webpack_public_path__ + "public/img/basic.ddb56bdf.png";